<template>
  <div>
    <div id="axcess-frame-scripts"></div>
    <form
      :action="returnUrl"
      class="paymentWidgets"
      data-brands="MASTER VISA"
    > </form>
  </div>
</template>
  
<script>
  export default {
    name: "AxcessFrame",
    data:()=>{
      return {
      }
    },
    props: {
      returnUrl: {
        type: String
      },
      scriptUrl: {
        type: String
      },
    },
    mounted() {
      if (this.scriptUrl) {
        this.insertScript(this.scriptUrl)
      }
    },
    methods:{
      insertScript(url){
        let script = document.createElement('script');
        let scriptContainer = document.getElementById('axcess-frame-scripts')
        script.type = 'text/javascript'
        script.src  = url
        scriptContainer.appendChild(script);
      },

    }
  }
</script>
  
<style scoped lang="scss">
  .gpay-btn {
    width: 100%;
  }
</style>